
import { Component, OnInit } from '@angular/core';
import { StoreService } from './../store.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  constructor(
    private $store: StoreService,
    private route: ActivatedRoute,
  ) { }


  ngOnInit() {
    var m = this.$store.router.params || this.$store.currentUser.email
    this.$store.getProfile(m)
      $(window).scroll(function() {
        if ($(document).scrollTop() > 50) {
          $('#foo').css('padding-bottom', '0px'); 
        } else {
          $('#foo').css('padding-bottom', '100px'); 
        }
      });
  }

  
  getSkills(type) {
    if (!this.$store.profile.skills) return []
    let searchedSkills = this.$store.profile.skills.filter(skill => skill.type === type)
    if (searchedSkills[0]) {
    searchedSkills[0].category ?   
    searchedSkills.sort((a, b) => 
        a.category === b.category ? a.skillName.localeCompare(b.skillName) : 
        a.category.localeCompare(b.category))
    : searchedSkills.sort((a, b) => a.skillName.localeCompare(b.skillName))
  return searchedSkills
    }
  }

  
}


// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/profile.component.ts